import React, { Component } from 'react';

import PageTable, {
  PageTableCell,
  PageTableHeader,
  PageTableRow,
} from '../../../components/Table/PageTable';
import {
  EnumMerchantStaffRoleOrder,
  EnumMerchantStaffStatus,
  EnumPagingMode,
  findEnumById,
} from '../../../constants/enum';
import { trans } from '../../../localization/index';

class StaffManagementTable extends Component {
  static renderHeader() {
    const columns = [
      {
        id: 'number',
        label: trans('set_staff_header_stt'),
        width: '5%',
        textAlign: 'center',
      },
      {
        id: 'avatar',
        label: trans('set_staff_header_avatar'),
        width: '10%',
        textAlign: 'center',
      },
      {
        id: 'info',
        label: trans('set_staff_header_info'),
        width: '50%',
        textAlign: 'left',
      },
      {
        id: 'role',
        label: trans('set_staff_header_role'),
        width: '25%',
        textAlign: 'left',
      },
      {
        id: 'edit',
        label: trans('set_staff_header_edit'),
        width: '10%',
        textAlign: 'center',
      },
    ];

    return <PageTableHeader columns={columns} />;
  }

  static renderEmpty() {
    return (
      <PageTableRow>
        <PageTableCell colSpan={5}>{trans('set_staff_not_find')}</PageTableCell>
      </PageTableRow>
    );
  }

  handleDeleteStaff = (staff) => {
    const { startConfirm, filters, updateStaff } = this.props;
    const { restaurant } = filters;

    function genBody() {
      const { staff_role: staffRole, uid } = staff;
      const reqParam = {
        restaurant_id: restaurant.value,
        staff_role: staffRole,
        status: EnumMerchantStaffStatus.DELETED.id,
        uid,
      };
      return reqParam;
    }
    startConfirm(
      trans('set_staff_delete_dish'),
      trans('set_staff_are_you_sure_delete_staff'),
      () => {
        const reqParam = genBody();
        updateStaff(reqParam);
      },
    );
  };

  renderRow = (row, index) => {
    const { openUpdateStaffModal } = this.props;
    const {
      avatar_url: avatarUrl,
      email,
      is_me: isMe,
      name,
      staff_role: staffRole,
      status,
      uid,
    } = row;
    const statusStaff = findEnumById(EnumMerchantStaffStatus, status);
    return (
      <PageTableRow key={uid}>
        <PageTableCell textAlign="center">{index}</PageTableCell>
        <PageTableCell textAlign="center">
          <img alt={name} src={avatarUrl} width={100} height={100} />
        </PageTableCell>
        <PageTableCell textAlign="left">
          {trans('set_staff_name')}: <strong>{name}</strong> <br />
          {trans('set_staff_email')}: <strong>{email}</strong>
        </PageTableCell>
        <PageTableCell textAlign="left">
          {`${trans(
            findEnumById(EnumMerchantStaffRoleOrder, staffRole).label,
          )} `}
          <strong className={statusStaff.class}>
            {trans(statusStaff.label)}
          </strong>
        </PageTableCell>
        <PageTableCell textAlign="center">
          {!isMe && (
            <div className="btn-wrap staff-btn-wrap">
              <button
                type="button"
                className="btn btn-block btn-red"
                onClick={() => openUpdateStaffModal(row)}
              >
                {trans('pos_dish_edit')}
              </button>
              <button
                type="button"
                className="btn now-modal-button-cancel btn-block btn-decline"
                onClick={() => this.handleDeleteStaff(row)}
              >
                {trans('pos_dish_delete')}
              </button>
            </div>
          )}
        </PageTableCell>
      </PageTableRow>
    );
  };

  render() {
    const { table, changeActivePage, changePageSize } = this.props;
    return (
      <PageTable
        className="order-table staff-table"
        paginationMode={EnumPagingMode.SELF_PAGING.id}
        table={table}
        renderHeader={StaffManagementTable.renderHeader}
        renderRow={this.renderRow}
        renderEmpty={StaffManagementTable.renderEmpty}
        changeActivePage={changeActivePage}
        changePageSize={changePageSize}
      />
    );
  }
}

export default StaffManagementTable;



// WEBPACK FOOTER //
// ./foody/src/pages/Staff/components/StaffManagementTable.jsx